module.exports = __webpack_public_path__ + "static/img/tabela.07b5e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/rc/tabela.png
// module id = XIik
// module chunks = 0